(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("React"), require("mobx"), require("sbRespLib"), require("sbRespUI"), require("mobxReact"));
	else if(typeof define === 'function' && define.amd)
		define("sb-responsive-league-list-presenter", ["React", "mobx", "sbRespLib", "sbRespUI", "mobxReact"], factory);
	else if(typeof exports === 'object')
		exports["sb-responsive-league-list-presenter"] = factory(require("React"), require("mobx"), require("sbRespLib"), require("sbRespUI"), require("mobxReact"));
	else
		root["sb-responsive-league-list-presenter"] = factory(root["React"], root["mobx"], root["sbRespLib"], root["sbRespUI"], root["mobxReact"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__3__, __WEBPACK_EXTERNAL_MODULE__4__, __WEBPACK_EXTERNAL_MODULE__5__, __WEBPACK_EXTERNAL_MODULE__27__) {
return 